import React from "react";
import Routes from './Routes';
import NetworkStatusIndicator from './components/NetworkStatusIndicator';
import { initializeErrorHandling } from './utils/errorHandler';
import { initializeConnectionMonitoring } from './lib/supabase';
import { useEffect } from 'react';
import { checkAndSendTaskDueReminders, checkAndSendMeetingReminders } from './services/notificationService';

function App() {
  useEffect(() => {
    // Initialize global error handling
    initializeErrorHandling();
    
    // Initialize connection monitoring
    const cleanupConnection = initializeConnectionMonitoring();
    
    return () => {
      cleanupConnection?.();
    };
  }, []);

  // Set up periodic notification checks
  React.useEffect(() => {
    // Check for task and meeting reminders every 10 minutes
    const interval = setInterval(async () => {
      console.log('🔔 Running scheduled notification checks...');
      
      try {
        await checkAndSendTaskDueReminders();
        await checkAndSendMeetingReminders();
      } catch (error) {
        console.error('Error in scheduled notification checks:', error);
      }
    }, 10 * 60 * 1000); // 10 minutes

    // Run immediately on app load
    checkAndSendTaskDueReminders();
    checkAndSendMeetingReminders();

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Routes />
      <NetworkStatusIndicator />
    </>
  );
}

export default App;